module.exports = __webpack_public_path__ + "img/attack_green_ivy.fc9f5455.png";